"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavAttachmentsSection = void 0;
const core_1 = require("@app/component/core");
const ui_1 = require("@app/component/ui");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const const_1 = require("@app/const");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const unavailability_context_1 = require("../unavailability-context");
const modal_section_1 = require("./modal-section");
const UnavAttachmentsSection = () => {
    const { formControl } = (0, unavailability_context_1.useUnavailability)();
    const { canWrite } = (0, util_1.useAccessRole)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const auth = (0, store_1.useRootSelector)((state) => state.auth);
    const employees = (0, store_1.useRootSelector)((state) => state.employees);
    const attachmentsController = (0, react_hook_form_1.useController)({
        control: formControl,
        name: 'attachments',
    });
    const attachments = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'attachments' });
    return (react_1.default.createElement(modal_section_1.ModalSection, { id: 'attachment' },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            react_1.default.createElement(ui_1.Flex, { direction: ui_1.Flex.DIRECTION.COLUMN },
                react_1.default.createElement(core_1.UploadButton, { workspaceId: workspace?.id ?? '', auth: auth, onUpload: (files) => attachmentsController.field.onChange(attachments ? [...attachments, ...files] : files) }),
                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_6 }),
                react_1.default.createElement(ui_1.Flex, null, attachments?.map((att) => {
                    const attType = att.filename?.split('.');
                    const author = employees[att.author];
                    let icoName = attType[attType.length - 1];
                    if (!Object.keys(ui_1.Icon.ICONS).includes(icoName)) {
                        icoName = 'file';
                    }
                    return (react_1.default.createElement(ui_1.Tooltip, { key: att.id, anchor: react_1.default.createElement(ui_1.Icon, { ico: ui_1.Icon.ICONS[icoName], onClick: () => util_1.miscUtil.downloadFile(att.url), size: ui_1.Icon.SIZES.EXTRA }) },
                        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_16, type: ui_1.Spacing.TYPES.BOTH },
                            react_1.default.createElement(ui_1.Flex, { direction: ui_1.Flex.DIRECTION.COLUMN, align: ui_1.Flex.POSITION.START },
                                react_1.default.createElement("div", null, att.filename),
                                react_1.default.createElement("div", null,
                                    att.size,
                                    " B"),
                                react_1.default.createElement("div", null, (0, moment_1.default)(att.created).format('MM.DD.YYYY')),
                                react_1.default.createElement("div", null, author?.name),
                                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_8 }),
                                (canWrite(const_1.PERMISSIONS.CALENDAR) ||
                                    canWrite(const_1.PERMISSIONS.BACKOFFICE.ATTENDANCE) ||
                                    canWrite(const_1.PERMISSIONS.BACKOFFICE.TIMEOFFREQUESTS)) && (react_1.default.createElement(ui_1.Button, { ico: ui_1.Icon.ICONS.delete, label: (0, util_1.t)('DELETE'), style: ui_1.Button.STYLES.UNDERLINED, color: ui_1.Button.COLORS.RED, onClick: () => attachmentsController.field.onChange(attachments.filter((item) => item.id !== att.id)) }))))));
                })))),
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_16 })));
};
exports.UnavAttachmentsSection = UnavAttachmentsSection;
